// The want-ad page is addressed by slug ("4-bed-2-bath-home-in-bhc"), and the
// slug used to be stored as wantAdId in localStorage. A slug is truthy and
// parseInt()s on the API to its leading number, so sending it attached an
// introduction to another user's want ad. Only a plain positive integer is an id.
export const toWantAdId = (value) => {
  const text = String(value ?? "");
  return /^[1-9]\d*$/.test(text) ? Number(text) : null;
};

// The id of the want ad that is actually loaded wins; the stored value is only
// a fallback and only when it is numeric.
export const resolveWantAdId = (loadedId, storedId) =>
  toWantAdId(loadedId) ?? toWantAdId(storedId);
